hasObjectAttributes = require 'modules/backbone/enhanced/utilities/object_has_attributes'

class Backbone.Enhanced.View extends Backbone.View

  # These are attributes that will be applied at the INSTANCE level
  ATTRIBUTES:
    id: null
    className: null
    tagName: null
    template: null

  constructor: (attributes)->

    # Do not set subviews when constructing
    if attributes && attributes.subViews
      throw new Error("Don't set subViews on initialize!")
    @subViews = {}

    # Give the view the incoming attributes
    hasObjectAttributes.apply(this, [attributes])

    if typeof(@get('template')) != 'undefined'
      @template = @get('template')
      @removeAttribute('template')

    super(@getAttributes())

  initialize: (options) =>
    super
    this

  render: =>
    # If we're running stickit() extension by NYTimes,
    # lets just call it so we don't have to call it all of the time
    # if @model and typeof(@stickit) == 'function'
    #   @stickit()
    this

  teardown: =>
    # Cycle through all subviews and clean them up as well
    for viewName, view of @subViews
      if view && typeof(view.teardown) == 'function'
        view.teardown()

    # Halt all listeners
    Backbone.View.prototype.off.apply(this, [])

    # Removes all event delegators attached to the containing `el`
    Backbone.View.prototype.undelegateEvents.apply(this, [])

    # Remove from the DOM Node
    Backbone.View.prototype.remove.apply(this, [])
    # Return `this`
    this


  globalTrigger: (name, data)=>
    Backbone.Enhanced.Events.trigger(name, data)
    this

  listenTo: (obj, name, callback)=>
    super
    this

# Give the object attribute abilities
_.extend(Backbone.Enhanced.View.prototype, hasObjectAttributes.prototype)

module.exports = Backbone.Enhanced.View